import { render, staticRenderFns } from "./MessageForClientModal.vue?vue&type=template&id=4867b69d&scoped=true&"
import script from "./MessageForClientModal.vue?vue&type=script&lang=js&"
export * from "./MessageForClientModal.vue?vue&type=script&lang=js&"
import style0 from "./MessageForClientModal.vue?vue&type=style&index=0&id=4867b69d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4867b69d",
  null
  
)

export default component.exports